<template>
  <div
    :class="[
      'whatsapp-float',
      { 'whatsapp-float--beta-dashboard': isBetaDashboard },
    ]"
  >
    <a :href="whatsappLink" target="_blank" rel="noopener noreferrer">
      <img
        src="https://epics-public-files.s3.us-east-1.amazonaws.com/images/whatsapp.png"
        alt="Suporte EPICS"
      />
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useUserStore } from '@/stores/user'
import { hasBetaPanelQuery } from '@/utils/panel-variant'

const userStore = useUserStore()
const route = useRoute()
const email = computed(() => userStore.email)
const name = computed(() => userStore.name)
const isBetaDashboard = computed(() => (
  route.name === 'dashboard' && hasBetaPanelQuery(route.query)
))

const mensagem = computed(() =>
  `Olá, preciso de ajuda do suporte. Abaixo estão meus dados:\n\n` +
  `Nome: ${name.value}\n` +
  `Email: ${email.value}\n`
)

const whatsappLink = computed(() =>
  `https://wa.me/5517981630625?text=${encodeURIComponent(mensagem.value)}`
)
</script>


<style scoped>
.whatsapp-float {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9999;
}

.whatsapp-float img {
  width: 40px;
  height: 40px;
  cursor: pointer;
}

@media (max-width: 767px) {
  .whatsapp-float--beta-dashboard {
    bottom: calc(88px + env(safe-area-inset-bottom));
    right: 16px;
  }
}
</style>
